import { BaseEvents } from '@/shared/utils';

export const HomepageEventsKeys = {
  homepage: {
    view: 'homepage/view',
  },
} as const;

export interface HomepageEvents extends BaseEvents {
  'homepage/view': { email: string };
}
